import React, { useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import Button from "./Button";
import { useContextApi } from "../../../context/ContextApi";
import { XIcon } from "../../../constants/Icons";

const AddWallet = ({ onClose, onNewWalletIn, isBtnLoading }) => {
  const [walletName, setWalletName] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const walletRef = useRef(null);
  const buttonRef = useRef(null)
  const {useEscapeKey}=useContextApi();
  const handleClose = () => {
    setWalletName("");
    setErrorMessage("");
    onClose();
  };
  useEscapeKey(handleClose);
  const handleOnNewWalletIn = (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    onNewWalletIn(walletName);
  };

  const validateForm = () => {
    if (!walletName.trim()) {
      setErrorMessage("WalletName cannot be empty.");
       walletRef?.current?.focus();
      return false;
    }
    if(walletName?.trim()?.length<3)
    setErrorMessage("Wallet name must contain at least 2 characters.");
    walletRef?.current?.focus();
    return true;
  };

  const handleInputChange = (e) => {
    setErrorMessage("")
    const { name, value } = e.target;
    let inputValue = value;
    if (name === "walletName") {
      inputValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
      setWalletName(inputValue);
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleOnNewWalletIn(e);
    }
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">New Wallet</h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="card w-100 radius-10 mb-0 shadow-none">
                <div className="card-body p-0">
                  <form className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        Wallet Name <small className="text-danger">*</small>
                      </label>
                      <input
                        ref={walletRef}
                        type="text"
                        autoComplete="off"
                        name="walletName"
                        className="form-control"
                        value={walletName}
                        onKeyDown={(e)=>handlePaymodeKeyDown(e)}
                        onChange={handleInputChange}
                        autoFocus
                      />
                      {errorMessage && (
                        <small className="text-danger">{errorMessage}</small>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={handleClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon/> Cancel
              </button>

              {isBtnLoading ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <Button
                  ref={buttonRef}
                  text="Add"
                  icon="bx bx-check"
                  bgColor="btn-primary"
                  textColor="text-white"
                  className="text-right"
                  onClick={handleOnNewWalletIn}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWallet;
